const DAYS_IN_WEEK = 7;
const pad = value => {
  return value.toString().padStart(2, '0');
};
export const getCalendarMonth = (date, options) => {
  const {
    firstDayOfWeek
  } = {
    firstDayOfWeek: 1,
    ...options
  };
  const firstDateOfMonth = new Date(Date.UTC(date.getUTCFullYear(), date.getUTCMonth(), 1));
  const lastDateOfMonth = new Date(Date.UTC(date.getUTCFullYear(), date.getUTCMonth() + 1, 0));
  const firstWeekdayOfMonth = firstDateOfMonth.getUTCDay();
  const lastWeekdayOfMonth = lastDateOfMonth.getUTCDay();
  const daysInMonth = lastDateOfMonth.getUTCDate();
  const daysToPrepend = (firstWeekdayOfMonth - firstDayOfWeek + DAYS_IN_WEEK) % DAYS_IN_WEEK;
  const daysToAppend = (DAYS_IN_WEEK - 1 - lastWeekdayOfMonth + firstDayOfWeek) % DAYS_IN_WEEK;
  const month = [];
  let week = [];
  for (let i = 1 - daysToPrepend; i <= daysInMonth + daysToAppend + 1; i++) {
    if (i <= 0 || i > daysInMonth) {
      week.push(null);
    } else {
      const result = new Date(date);
      result.setUTCDate(i);
      week.push(result);
    }
    if (week.length === 7) {
      month.push(week);
      week = [];
    }
  }
  return month;
};
export const dateToIso = date => {
  return `${date.getUTCFullYear()}-${pad(date.getUTCMonth() + 1)}-${pad(date.getUTCDate())}`;
};
export const isoToDate = value => {
  return new Date(`${value.substring(0, 10)}T00:00:00Z`);
};
export const today = () => {
  const today = new Date();
  return new Date(Date.UTC(today.getUTCFullYear(), today.getUTCMonth(), today.getUTCDate()));
};
export const getDayNames = locale => {
  const formatter = new Intl.DateTimeFormat(locale, {
    weekday: 'narrow',
    timeZone: 'UTC'
  });
  return [1, 2, 3, 4, 5, 6, 7].map(dd => {
    const date = new Date(Date.UTC(2018, 0, dd));
    return formatter.format(date);
  });
};
export const getMonthNames = locale => {
  const formatter = new Intl.DateTimeFormat(locale, {
    month: 'short',
    timeZone: 'UTC'
  });
  return [0, 1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11].map(mm => {
    const date = new Date(Date.UTC(2018, mm, 1));
    return formatter.format(date);
  });
};
export const isValidDate = value => {
  return value instanceof Date && !isNaN(value);
};
export const compareDates = (a, b) => {
  return a.getTime() - b.getTime();
};
export const clampMinDate = (date, min) => {
  if (compareDates(min, date) > 0) {
    date.setTime(min.getTime());
  }
};
export const clampMaxDate = (date, max) => {
  if (compareDates(date, max) > 0) {
    date.setTime(max.getTime());
  }
};
export const incMonth = (date, max) => {
  date.setUTCMonth(date.getUTCMonth() + 1);
  clampMaxDate(date, max);
};
export const decMonth = (date, min) => {
  date.setUTCMonth(date.getUTCMonth() - 1);
  clampMinDate(date, min);
};
export const incYear = (date, max) => {
  date.setUTCFullYear(date.getUTCFullYear() + 1);
  clampMaxDate(date, max);
};
export const decYear = (date, min) => {
  date.setUTCFullYear(date.getUTCFullYear() - 1);
  clampMinDate(date, min);
};
export const canGoPrevMonth = (date, min) => {
  const prevMonth = new Date(Date.UTC(date.getUTCFullYear(), date.getUTCMonth(), 0));
  return compareDates(prevMonth, min) >= 0;
};
export const canGoNextMonth = (date, max) => {
  const nextMonth = new Date(Date.UTC(date.getUTCFullYear(), date.getUTCMonth() + 1, 1));
  return compareDates(max, nextMonth) >= 0;
};
export const canGoNextYear = (date, max) => {
  const nextYear = new Date(Date.UTC(date.getUTCFullYear() + 1, 0, 1));
  return compareDates(max, nextYear) >= 0;
};
export const canGoPrevYear = (date, min) => {
  const prevYear = new Date(Date.UTC(date.getUTCFullYear(), 0, 0));
  return compareDates(prevYear, min) >= 0;
};
export const isDateBetween = (date, min, max) => {
  if (min === null || max === null) {
    return false;
  }
  return compareDates(date, min) >= 0 && compareDates(max, date) >= 0;
};
export const areDatesEqual = (a, b) => {
  if (b === null) {
    return false;
  }
  return compareDates(a, b) === 0;
};
export const cloneDate = date => {
  return new Date(date.getTime());
};
export const sortDates = dateTuple => {
  if (compareDates(dateTuple[0], dateTuple[1]) > 0) {
    return [dateTuple[1], dateTuple[0]];
  }
  return dateTuple;
};
export const isDateOnScreen = (uiDate, date) => {
  if (uiDate === null || date === null) {
    return false;
  }
  const firstDateOfMonth = new Date(Date.UTC(uiDate.getUTCFullYear(), uiDate.getUTCMonth(), 1));
  const lastDateOfMonth = new Date(Date.UTC(uiDate.getUTCFullYear(), uiDate.getUTCMonth() + 1, 0));
  return isDateBetween(date, firstDateOfMonth, lastDateOfMonth);
};